import React from 'react';
import { useFormikContext } from 'formik';

import { Button } from 'components/Button';

import { FooterLeftSlot, SaveStatePill, StickyFooter } from './styles';
import { DocumentSettingsFormValues } from './types';
import { getDefaultFormValues } from './useDocumentSettingsForm';

const SettingsFormActions: React.FC = () => {
  const { dirty, isSubmitting, isValid, resetForm, setValues } = useFormikContext<DocumentSettingsFormValues>();

  // Resetting only repopulates the form — nothing is persisted until Save
  // changes, and Cancel reverts it, so no confirmation step is needed.
  const handleResetToDefaults = (): void => {
    setValues(getDefaultFormValues());
  };

  return (
    <StickyFooter>
      <FooterLeftSlot>
        <Button variant="text" size="medium" disabled={isSubmitting} onClick={handleResetToDefaults}>
          Reset to defaults
        </Button>
        <SaveStatePill $dirty={dirty} aria-live="polite">
          {dirty ? 'Unsaved changes' : 'All changes saved'}
        </SaveStatePill>
      </FooterLeftSlot>
      <Button variant="outlined" size="medium" disabled={!dirty || isSubmitting} onClick={() => resetForm()}>
        Cancel
      </Button>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        size="medium"
        disabled={!dirty || !isValid || isSubmitting}
      >
        Save changes
      </Button>
    </StickyFooter>
  );
};

export default SettingsFormActions;
